@if (mode === 'chips') {

  <vl-chips iconLeft="qr_code_scanner" (action)="openQrCode()" state="secondary">{{ label }}</vl-chips>
}

@if (mode === 'big-button') {
  <vl-big-button icon="qr_code_scanner" (action)="openQrCode()" color="secondary" [text]="label"></vl-big-button>
}
